import React, { useState, useEffect } from "react";
import "./IntegrationModals.css";
import { FaWhatsapp, FaEnvelope, FaPlug } from "react-icons/fa";
import { api } from "../../../services/api";

const ICON_MAP = {
    whatsapp_evolution: FaWhatsapp,
    email_smtp: FaEnvelope,
    other: FaPlug,
};

const EditIntegrationModal = ({
    isOpen,
    onClose,
    integration,
    onSave,
}) => {
    const [label, setLabel] = useState(integration?.label || "");
    const [credentials, setCredentials] = useState({
        token: "",
        instance_id: integration?.credentials?.summary?.instance_id || "",
        host: integration?.credentials?.summary?.host || "",
        email_host: integration?.credentials?.summary?.host || "",
        port: integration?.credentials?.summary?.port || 587,
        username: integration?.credentials?.summary?.username || "",
        password: "",
        use_tls: integration?.credentials?.summary?.use_tls ?? true,
        use_ssl: integration?.credentials?.summary?.use_ssl ?? false,
        sender_name: integration?.credentials?.summary?.sender_name || "",
    });
    const [loading, setLoading] = useState(false);


    useEffect(() => {
        if (isOpen && integration) {
            setLabel(integration.label || "");
            setCredentials({
                token: "",
                instance_id: integration?.credentials?.summary?.instance_id || "",
                host: integration?.credentials?.summary?.host || "",
                email_host: integration?.credentials?.summary?.host || "",
                port: integration?.credentials?.summary?.port || 587,
                username: integration?.credentials?.summary?.username || "",
                password: "",
                use_tls: integration?.credentials?.summary?.use_tls ?? true,
                use_ssl: integration?.credentials?.summary?.use_ssl ?? false,
                sender_name: integration?.credentials?.summary?.sender_name || "",
            });
        }
    }, [isOpen, integration]);

    if (!isOpen || !integration) return null;

    const Icon = ICON_MAP[integration.key] || FaPlug;

    const handleCredentialChange = (e) => {
        const { name, value } = e.target;

        if (name === "port") {
            setCredentials((prev) => ({
                ...prev,
                port: Number(value) || 0,
            }));
            return;
        }

        if (name === "use_tls" || name === "use_ssl") {
            setCredentials((prev) => ({
                ...prev,
                [name]: value === "true",
            }));
            return;
        }

        setCredentials((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            if (label !== integration.label) {
                await api.put(`/api/integrations/${integration.id}`, {
                    display_label: label,
                });
            }

            let credentialsPayload;

            if (integration.key === "whatsapp_evolution") {
                const tokenProvided = credentials.token && credentials.token.trim();
                const hostProvided = credentials.host && credentials.host.trim();
                const instanceIdProvided = credentials.instance_id && credentials.instance_id.trim();


                const originalHost = integration?.credentials?.summary?.host || "";
                const originalInstanceId = integration?.credentials?.summary?.instance_id || "";

                const hostChanged = hostProvided && hostProvided !== originalHost;
                const instanceIdChanged = instanceIdProvided && instanceIdProvided !== originalInstanceId;
                const tokenChanged = tokenProvided;
                const isChangingCredentials = tokenChanged || hostChanged || instanceIdChanged;

                if (isChangingCredentials) {

                    credentialsPayload = {
                        credentials: {
                            host: credentials.host.trim(),
                            instance_id: credentials.instance_id.trim(),
                            webhook_url: null,
                        },
                    };


                    if (tokenProvided) {
                        credentialsPayload.credentials.token = credentials.token.trim();
                    }
                }
            } else if (integration.key === "email_smtp") {
                const passwordProvided = credentials.password && credentials.password.trim();
                const hostProvided = credentials.email_host && credentials.email_host.trim();
                const usernameProvided = credentials.username && credentials.username.trim();


                const originalHost = integration?.credentials?.summary?.host || "";
                const originalUsername = integration?.credentials?.summary?.username || "";

                const hostChanged = hostProvided && hostProvided !== originalHost;
                const usernameChanged = usernameProvided && usernameProvided !== originalUsername;
                const passwordChanged = passwordProvided;


                const isChangingCredentials = passwordChanged || hostChanged || usernameChanged;

                if (isChangingCredentials) {

                    credentialsPayload = {
                        credentials: {
                            host: credentials.email_host.trim(),
                            port: Number(credentials.port) || 587,
                            username: credentials.username.trim(),
                            use_tls: credentials.use_tls,
                            use_ssl: credentials.use_ssl,
                            sender_name: credentials.sender_name && credentials.sender_name.trim() ? credentials.sender_name.trim() : null,
                        },
                    };


                    if (passwordProvided) {
                        credentialsPayload.credentials.password = credentials.password.trim();
                    }
                }
            }

            if (credentialsPayload) {
                await api.put(`/api/integrations/${integration.id}`, credentialsPayload);

                let shouldCloseModal = true;

                if (integration.key === "whatsapp_evolution") {
                    try {
                        const testResponse = await api.get(`/api/integrations/${integration.id}/test-connection`);
                        const testData = testResponse.data;

                        if (testData.status === 'connected') {
                            alert('Canal conectado com sucesso!');
                            shouldCloseModal = true;
                        } else if (testData.status === 'disconnected') {
                            shouldCloseModal = false;

                            if (testData.error && testData.error.includes('404')) {
                                alert('Instância não encontrada!\n\nVerifique se os dados de integração estão corretos:\n• Nome da instância está correto\n• URL da Evolution API está correta\n• Instância foi criada no Evolution API Manager');
                            } else if (testData.error && testData.error.includes('401')) {
                                alert('Autenticação falhou!\n\nVerifique se os dados de integração estão corretos:\n• API Key está correta\n• API Key corresponde à configurada no Evolution API');
                            } else if (testData.error && (testData.error.includes('timeout') || testData.error.includes('ECONNREFUSED'))) {
                                alert('Servidor Evolution API não responde!\n\nVerifique se os dados de integração estão corretos:\n• Evolution API está online\n• URL está correta e acessível\n• Firewall não está bloqueando');
                            } else {
                                alert(`Desconectado\n\n${testData.error || 'WhatsApp não está conectado nesta instância.\n\nAcesse o Evolution API Manager e escaneie o QR Code.'}`);
                            }
                        } else {
                            shouldCloseModal = false;
                            alert(`${testData.error || 'Erro ao conectar'}`);
                        }
                    } catch (testError) {
                        shouldCloseModal = false;

                        if (testError.response) {
                            const { status, data } = testError.response;

                            if (status === 404) {
                                alert('Integração não encontrada no sistema');
                            } else if (status === 401 || status === 403) {
                                alert('Sessão expirada. Faça login novamente.');
                            } else {
                                alert(data.error || data.detail || 'Erro ao testar conexão');
                            }
                        } else if (testError.request) {
                            alert('Sem conexão com o servidor\n\nVerifique sua conexão com a internet');
                        } else {
                            alert('Erro ao testar conexão. Tente novamente.');
                        }
                    }
                } else {
                    alert('Credenciais salvas com sucesso!');
                    shouldCloseModal = true;
                }

                if (!shouldCloseModal) {
                    setLoading(false);
                    return;
                }
            } else {
                alert('Nome da integração atualizado com sucesso!');
            }

            onClose();

            if (typeof onSave === "function") {
                onSave();
            }
        } catch (error) {
            const errorMessage = error.response?.data?.detail
                || error.response?.data?.error
                || error.response?.data?.message
                || error.message
                || "Erro ao atualizar integração";

            alert(errorMessage);
        } finally {
            setLoading(false);
        }
    };

    const renderCredentialFields = () => {
        if (integration.key === "whatsapp_evolution") {
            return (
                <>
                    <div className="int-form-group">
                        <label htmlFor="token">API Key</label>
                        <input
                            id="token"
                            name="token"
                            type="text"
                            value={credentials.token}
                            onChange={handleCredentialChange}
                            placeholder="Insira sua API Key aqui"
                        />
                    </div>

                    <div className="int-form-group">
                        <label htmlFor="instance_id">Nome da instância *</label>
                        <input
                            id="instance_id"
                            name="instance_id"
                            type="text"
                            value={credentials.instance_id}
                            onChange={handleCredentialChange}
                            placeholder="Ex: fastteam_main_instance"
                            required
                        />
                    </div>

                    <div className="int-form-group">
                        <label htmlFor="host">URL da Evolution API *</label>
                        <input
                            id="host"
                            name="host"
                            type="text"
                            value={credentials.host}
                            onChange={handleCredentialChange}
                            placeholder="Ex: http://evolution-api:8080"
                            required
                        />
                    </div>
                </>
            );
        }

        if (integration.key === "email_smtp") {
            return (
                <>
                    <div className="int-form-group">
                        <label htmlFor="email_host">Mail Server (Host) *</label>
                        <input
                            id="email_host"
                            name="email_host"
                            type="text"
                            value={credentials.email_host}
                            onChange={handleCredentialChange}
                            placeholder="Ex: smtp.gmail.com"
                            required
                        />
                    </div>

                    <div className="int-form-group">
                        <label htmlFor="port">Porta *</label>
                        <input
                            id="port"
                            name="port"
                            type="number"
                            value={credentials.port}
                            onChange={handleCredentialChange}
                            placeholder="Ex: 587 ou 465"
                            required
                        />
                    </div>

                    <div className="int-form-group">
                        <label htmlFor="use_tls">Usar TLS *</label>
                        <select
                            id="use_tls"
                            name="use_tls"
                            value={credentials.use_tls ? "true" : "false"}
                            onChange={handleCredentialChange}
                            required
                        >
                            <option value="true">Sim</option>
                            <option value="false">Não</option>
                        </select>
                    </div>

                    <div className="int-form-group">
                        <label htmlFor="use_ssl">Usar SSL *</label>
                        <select
                            id="use_ssl"
                            name="use_ssl"
                            value={credentials.use_ssl ? "true" : "false"}
                            onChange={handleCredentialChange}
                            required
                        >
                            <option value="false">Não</option>
                            <option value="true">Sim</option>
                        </select>
                    </div>

                    <div className="int-form-group">
                        <label htmlFor="username">Usuário (login) *</label>
                        <input
                            id="username"
                            name="username"
                            type="email"
                            value={credentials.username}
                            onChange={handleCredentialChange}
                            placeholder="Seu usuário de e-mail / SMTP"
                            required
                        />
                    </div>

                    <div className="int-form-group">
                        <label htmlFor="password">Senha / App Password</label>
                        <input
                            id="password"
                            name="password"
                            type="password"
                            value={credentials.password}
                            onChange={handleCredentialChange}
                            placeholder="Senha do SMTP ou App Password"
                        />
                    </div>

                    <div className="int-form-group">
                        <label htmlFor="sender_name">
                            Nome do remetente (opcional)
                        </label>
                        <input
                            id="sender_name"
                            name="sender_name"
                            type="text"
                            value={credentials.sender_name}
                            onChange={handleCredentialChange}
                            placeholder="Ex: Equipe FASTTEAM"
                        />
                    </div>
                </>
            );
        }

        return null;
    };

    return (
        <div className="int-modal-backdrop" onClick={onClose}>
            <div className="int-modal" onClick={(e) => e.stopPropagation()}>
                <div className="int-modal-header">
                    <div className="int-modal-title-wrap">
                        <Icon className="int-channel-icon" />
                        <div>
                            <h3>Editar Integração</h3>
                            <p>Atualize o nome e as credenciais da integração.</p>
                        </div>
                    </div>
                    <button
                        type="button"
                        className="int-modal-close"
                        onClick={onClose}
                        disabled={loading}
                    >
                        ✕
                    </button>
                </div>

                <form onSubmit={handleSubmit} className="int-modal-form">
                    <div className="int-modal-body">
                        <div className="int-form-group">
                            <label htmlFor="integration_label">Nome da Integração *</label>
                            <input
                                id="integration_label"
                                name="integration_label"
                                type="text"
                                value={label}
                                onChange={(e) => setLabel(e.target.value)}
                                placeholder="Ex: WhatsApp Vendas"
                                required
                            />
                        </div>

                        {renderCredentialFields()}
                    </div>

                    <div className="int-modal-footer">
                        <button
                            type="button"
                            className="int-btn-outline"
                            onClick={onClose}
                            disabled={loading}
                        >
                            Cancelar
                        </button>
                        <button
                            type="submit"
                            className="int-btn-primary"
                            disabled={loading}
                        >
                            {loading ? "Salvando..." : "Salvar alterações"}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default EditIntegrationModal;
